// assets/card-product.js
(() => {
  const $$ = (s, e = document) => [...e.querySelectorAll(s)];
  const norm = (s) =>
    (s || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^\w]+/g, "-");

  const money = (c) =>
    window.Shopify?.formatMoney
      ? Shopify.formatMoney(c, Shopify.money_format)
      : (c / 100).toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
        });

  // =========================
  // ✅ helper para marcar origem ATC nos tamanhos
  // =========================
  function applyAtcOriginToSizeOption(el, bag) {
    if (!el || !bag) return;

    const origin = bag.getAttribute("data-origem-atc");
    if (!origin) return;

    el.setAttribute("data-origem-atc", origin);
  }

  // ===== Cache das quantidades no carrinho =====
  // Atualizado por qualquer evento cart:updated que traga o carrinho.
  // Evita uma ida ao servidor (/cart.js) antes de cada adição.
  const cartQty = new Map();
  let cartQtyKnown = false;
  function syncCartQty(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    cartQty.clear();
    cart.items.forEach((it) => {
      const k = String(it.variant_id);
      cartQty.set(k, (cartQty.get(k) || 0) + Number(it.quantity || 0));
    });
    cartQtyKnown = true;
  }
  document.addEventListener("cart:updated", (e) => syncCartQty(e.detail && e.detail.cart));

  function toast(msg) {
    if (window.showToast) window.showToast(msg, { type: "warning", duration: 3500 });
  }

  function init(card) {
    if (card.__i) return;
    card.__i = true;

    // Se o card está dentro das recomendações do carrinho,
    // deixamos toda a lógica para cart-recommendations.js
    if (card.closest(".cart-drawer__recommendations-grid")) {
      return;
    }

    // Trata corretamente produtos sem índice de cor (data-color-index vazio)
    const colorIndexRaw = card.dataset.colorIndex;
    const colorIndex =
      colorIndexRaw === "" || colorIndexRaw == null
        ? NaN
        : Number(colorIndexRaw);

    const variants = JSON.parse(
      card.querySelector(".cp-variants-json")?.textContent || "[]"
    );

    // Pré-carrega todas as imagens das variantes
    variants.forEach(v => {
      if (v.featured_media_url) {
        const preload = new Image();
        preload.src = v.featured_media_url;
      }
      if (v.media_gallery) {
        v.media_gallery.forEach(m => {
          if (m.image) {
            const preload = new Image();
            preload.src = m.image;
          }
        });
      }
    });

    const img = card.querySelector(".cp-img--primary");
    const hover = card.querySelector(".cp-hover");
    const price = card.querySelector("[data-price]");
    const compare = card.querySelector("[data-compare]");
    const bag = card.querySelector(".cp-bag-toggle");
    if (!bag) return;

    // LINKS DO CARD (imagem + título)
    const mediaLink = card.querySelector(".cp-media");
    const titleLink = card.querySelector(".cp-title a");
    let baseProductUrl = null;

    if (mediaLink && mediaLink.getAttribute("href")) {
      const href = mediaLink.getAttribute("href");
      try {
        const url = new URL(href, window.location.origin);
        url.search = "";
        url.hash = "";
        baseProductUrl = url.toString();
      } catch (e) {
        baseProductUrl = href;
      }
    } else if (titleLink && titleLink.getAttribute("href")) {
      const href = titleLink.getAttribute("href");
      try {
        const url = new URL(href, window.location.origin);
        url.search = "";
        url.hash = "";
        baseProductUrl = url.toString();
      } catch (e) {
        baseProductUrl = href;
      }
    }

    function updateLinksForVariant(variantId) {
      if (!baseProductUrl || !variantId) return;

      const separator = baseProductUrl.includes("?") ? "&" : "?";
      const variantUrl = `${baseProductUrl}${separator}variant=${variantId}`;

      if (mediaLink) mediaLink.href = variantUrl;
      if (titleLink) titleLink.href = variantUrl;

      card.dataset.currentVariantId = String(variantId);
    }

    const bagIcon = bag.querySelector(".cp-bag-icon");
    const closeIcon = bag.querySelector(".btn-close-variant");
    const sizeWrap = bag.querySelector(".variant-options-wrapper");

    function closeBag() {
      bag.dataset.open = "false";
      bag.setAttribute("aria-expanded", "false");
      bag.setAttribute(
        "aria-label",
        "Selecionar tamanho e adicionar ao carrinho"
      );
      if (closeIcon) closeIcon.hidden = true;
      if (bagIcon) bagIcon.hidden = false;
      if (sizeWrap) sizeWrap.hidden = true;
    }

    function openBag() {
      bag.dataset.open = "true";
      bag.setAttribute("aria-expanded", "true");
      bag.setAttribute("aria-label", "Fechar seleção de tamanho");
      if (bagIcon) bagIcon.hidden = true;
      if (closeIcon) closeIcon.hidden = false;
      if (sizeWrap) sizeWrap.hidden = false;
    }

    // =========================
    // ✅ loading helper (CORRIGIDO)
    // - fecha SEMPRE antes de carregar
    // - impede clique duplo
    // =========================
    function setBagLoading(on) {
      if (on) closeBag(); // 🔥 garante aria-expanded=false antes do loading

      bag.classList.toggle("is-loading", !!on);
      bag.setAttribute("aria-busy", on ? "true" : "false");
      bag.disabled = !!on;

      if (on) bag.dataset.loading = "true";
      else delete bag.dataset.loading;
    }

    // Normaliza estado inicial SEMPRE fechado
    bag.classList.remove("open");
    bag.dataset.open = "false";
    bag.setAttribute("aria-expanded", "false");
    setBagLoading(false);

    if (bagIcon) bagIcon.hidden = false;
    if (closeIcon) closeIcon.hidden = true;
    if (sizeWrap) sizeWrap.hidden = true;

    // Cálculo mais robusto de sizeIndex
    let sizeIndex = null;
    const optLen = variants[0]?.options?.length ?? 0;

    if (!Number.isNaN(colorIndex) && colorIndex >= 0 && optLen > 1) {
      // Tem cor + outra opção (ex: tamanho)
      sizeIndex = variants[0].options.findIndex((_, i) => i !== colorIndex);
      if (sizeIndex < 0) sizeIndex = null;
    } else if (optLen === 1) {
      // Produto que só tem tamanho (sem cor)
      sizeIndex = 0;
    }

    function pick(color) {
      if (Number.isNaN(colorIndex) || color == null) {
        // Sem cor: retorna sempre o primeiro variant
        return variants[0];
      }
      return (
        variants.find((v) => norm(v.options?.[colorIndex]) === norm(color)) ||
        variants[0]
      );
    }

    function setHover(v) {
      if (!hover || !v) return;
      hover.innerHTML = "";
      const g = v.media_gallery || [];
      const i = g.findIndex(
        (m) => String(m.id) === String(v.featured_media_id)
      );
      const nx = g[i + 1];
      if (!nx) return;

      if (nx.type === "video" && nx.video) {
        const dv = document.createElement("video");
        dv.src = nx.video;
        dv.muted = true;
        dv.loop = true;
        dv.autoplay = true;
        dv.playsInline = true;
        hover.appendChild(dv);
      } else if (nx.image) {
        const im = document.createElement("img");
        im.src = nx.image;

        const hoverAlt =
          hover && hover.dataset && hover.dataset.hoverAlt
            ? hover.dataset.hoverAlt
            : "";
        im.alt = hoverAlt;

        hover.appendChild(im);
      }
    }

    // ===== Adicionar ao carrinho: otimista, 1 requisição, com animação até a sacola =====
    async function addVariantToCart(variant) {
      if (!variant || !variant.id) return;
      if (bag.dataset.loading === "true") return;

      const invQtyRaw = variant.inventory_quantity;
      const invQty = typeof invQtyRaw === "number" ? invQtyRaw : parseInt(invQtyRaw || "0", 10);
      const invPolicy = variant.inventory_policy || "deny";

      if (invPolicy === "deny" && (!invQty || invQty <= 0)) {
        toast("Este tamanho está indisponível no momento.");
        return;
      }
      if (cartQtyKnown && invPolicy === "deny" && invQty > 0 && (cartQty.get(String(variant.id)) || 0) >= invQty) {
        toast("Você já possui a quantidade máxima deste item no carrinho.");
        return;
      }

      // trava cliques repetidos sem mostrar spinner (a resposta visual é a animação)
      bag.dataset.loading = "true";
      bag.setAttribute("aria-busy", "true");
      closeBag();
      updateLinksForVariant(variant.id);

      const FLY = window.IallyCartFly;
      const img = card.querySelector(".cp-media .cp-img--primary") || card.querySelector(".cp-media img");
      const flight = FLY ? FLY.fly(img) : Promise.resolve();
      const countBefore = FLY ? FLY.readCount() : 0;
      // contador otimista: nunca soma duas vezes se o servidor já tiver respondido
      if (FLY) flight.then(() => { FLY.setCount(Math.max(FLY.readCount(), countBefore + 1)); FLY.bump(0); });

      const drawer = window.CART_DRAWER || {};
      const sectionId = typeof drawer.sectionId === "function" ? drawer.sectionId() : null;
      const body = { items: [{ id: variant.id, quantity: 1 }] };
      if (sectionId) {
        body.sections = sectionId;
        body.sections_url = window.location.pathname;
      }

      let ok = false;
      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Ially-Quick-Add": "1",
          },
          body: JSON.stringify(body),
        });

        if (!res.ok) {
          let msg = "Não foi possível adicionar este item ao carrinho.";
          try {
            const err = await res.json();
            if (res.status === 422) msg = "Você já possui a quantidade máxima deste item no carrinho.";
            else if (err && err.description) msg = String(err.description);
          } catch (_) {}
          toast(msg);
          return;
        }

        ok = true;
        const json = await res.json();
        cartQty.set(String(variant.id), (cartQty.get(String(variant.id)) || 0) + 1);

        // atualiza o drawer com o HTML que veio na mesma resposta (sem nova requisição)
        const html = json && json.sections && sectionId ? json.sections[sectionId] : null;
        if (html && typeof drawer.applyHtml === "function") drawer.applyHtml(html);
        else if (typeof drawer.reload === "function") drawer.reload();

        document.dispatchEvent(new CustomEvent("cart:updated"));
        if (typeof drawer.updateCount === "function") drawer.updateCount(); // confirma o número real em segundo plano

        bag.classList.add("is-added");
        setTimeout(() => bag.classList.remove("is-added"), 1400);

        await flight;
        if (window.IALLY_QUICK_ADD_OPEN_DRAWER !== false && typeof drawer.open === "function") drawer.open();
      } catch (e) {
        toast("Sem conexão. Não foi possível adicionar este item.");
      } finally {
        if (!ok && FLY) flight.then(() => FLY.setCount(countBefore));
        delete bag.dataset.loading;
        bag.setAttribute("aria-busy", "false");
      }
    }

    function makeSizeAccessible(b, available) {
      b.setAttribute("role", "button");
      b.setAttribute("tabindex", "0");
      b.setAttribute("aria-label", "Tamanho " + b.dataset.size + (available ? "" : ", esgotado"));
      if (!available) b.setAttribute("aria-disabled", "true");
      b.addEventListener("keydown", (ev) => {
        if (ev.key === "Enter" || ev.key === " ") {
          ev.preventDefault();
          ev.stopPropagation();
          b.click();
        }
      });
    }

    function rebuildSizesFor(color) {
      if (!sizeWrap) return;
      sizeWrap.innerHTML = "";
      if (sizeIndex == null || sizeIndex < 0) return;

      const used = new Set();

      // Sem cor: lista todos os tamanhos disponíveis
      if (Number.isNaN(colorIndex) || color == null) {
        variants.forEach((x) => {
          const s = x.options?.[sizeIndex];
          if (!s || used.has(s)) return;
          used.add(s);

          const b = document.createElement("div");
          b.className = "variant-size-option";

          // ✅ tracking no clique do tamanho
          applyAtcOriginToSizeOption(b, bag);

          b.dataset.size = s;
          b.dataset.variantId = x.id;
          b.dataset.available = !!x.available;
          b.textContent = s;

          makeSizeAccessible(b, !!x.available);
          b.onclick = (ev) => {
            if (ev) ev.stopPropagation();
            if (!x.available) {
              if (window.showToast) {
                window.showToast("Este tamanho está indisponível no momento.", {
                  type: "warning",
                  duration: 3000,
                });
              }
              return;
            }
            addVariantToCart(x);
          };

          sizeWrap.appendChild(b);
        });
        return;
      }

      // Com cor: filtra por cor escolhida
      variants.forEach((x) => {
        if (norm(x.options?.[colorIndex]) !== norm(color)) return;
        const s = x.options?.[sizeIndex];
        if (!s || used.has(s)) return;
        used.add(s);

        const b = document.createElement("div");
        b.className = "variant-size-option";

        // ✅ tracking no clique do tamanho
        applyAtcOriginToSizeOption(b, bag);

        b.dataset.color = norm(color);
        b.dataset.size = s;
        b.dataset.variantId = x.id;
        b.dataset.available = !!x.available;
        b.textContent = s;

        makeSizeAccessible(b, !!x.available);
        b.onclick = (ev) => {
          if (ev) ev.stopPropagation();
          if (!x.available) {
            if (window.showToast) {
              window.showToast("Este tamanho está indisponível no momento.", {
                type: "warning",
                duration: 3000,
              });
            }
            return;
          }
          addVariantToCart(x);
        };

        sizeWrap.appendChild(b);
      });
    }

    function update(color) {
      const v = pick(color);

      if (v?.featured_media_url && img) {
        // Troca instantânea sem esperar load
        img.src = v.featured_media_url;

        try {
          const base = String(v.featured_media_url || "");
          function withSize(u, size) {
            return u.replace(/_(\d+)x\./, `_${size}x.`);
          }
          const s200 = withSize(base, 200);
          const s400 = withSize(base, 400);
          const s600 = withSize(base, 600);
          const s800 = withSize(base, 800);
          img.srcset = `${s200} 200w, ${s400} 400w, ${s600} 600w, ${s800} 800w`;
          img.sizes =
            "(max-width: 768px) 48vw, (max-width: 1200px) 260px, 320px";
        } catch (_) {}
      }

      setHover(v);

      if (price && v) price.textContent = money(v.price || 0);

      if (compare) {
        if (v?.compare_at_price > v?.price) {
          compare.hidden = false;
          compare.textContent = money(v.compare_at_price);
        } else {
          compare.hidden = true;
        }
      }

      const badge = card.querySelector(".cp-discount-badge");
      if (badge) {
        const ca = Number(v?.compare_at_price || 0);
        const p = Number(v?.price || 0);
        if (ca > p && ca > 0) {
          const d = Math.round(((ca - p) * 100) / ca);
          badge.textContent = "-" + d + "%";
          badge.hidden = false;
        } else {
          badge.textContent = "";
          badge.hidden = true;
        }
      }

      card.dataset.currentColor = norm(color || "");

      rebuildSizesFor(color);

      if (v?.id) updateLinksForVariant(v.id);

      closeBag();

      try {
        card.dispatchEvent(
          new CustomEvent("cp:variant-updated", { bubbles: true })
        );
      } catch (_) {}
    }

    function getCurrentColorKey() {
      if (!Number.isNaN(colorIndex) && colorIndex >= 0) {
        if (card.dataset.currentColor) return card.dataset.currentColor;
        const swSel = card.querySelector(".cp-swatch__input:checked");
        if (swSel) return norm(swSel.value);
        const first = variants[0]?.options?.[colorIndex];
        return norm(first || "");
      }
      return null;
    }

    const swatches = [...card.querySelectorAll(".cp-swatch__input")];
    swatches.forEach((r) => {
      r.onchange = () => {
        if (r.checked) update(r.value);
      };
    });

    // Se tiver swatches de cor, inicializa com a primeira
    if (swatches[0]) {
      update(swatches[0].value);
    } else {
      // Sem cor: só garante bag fechado, deixa imagem base do Liquid
      closeBag();
    }

    bag.addEventListener("click", (e) => {
      e.stopPropagation();

      // se estiver carregando, ignora clique
      if (bag.dataset.loading === "true") return;

      let autoVariant = null;

      const currentColorKey = getCurrentColorKey();
      if (!Number.isNaN(colorIndex) && currentColorKey && sizeIndex != null) {
        const list = variants.filter(
          (v) => norm(v.options?.[colorIndex]) === currentColorKey
        );

        // se só existe 1 variante pra essa cor (sem tamanho), adiciona direto
        if (list.length === 1 && list[0]?.available) {
          autoVariant = list[0];
        }
      }

      // produto sem opções (1 variante)
      if (!autoVariant && variants.length === 1 && variants[0]?.available) {
        autoVariant = variants[0];
      }

      if (autoVariant) {
        // ✅ também faz loading (pois passa no addVariantToCart)
        addVariantToCart(autoVariant);
        return;
      }

      bag.dataset.open === "true" ? closeBag() : openBag();
    });

    if (closeIcon) {
      closeIcon.addEventListener("click", (e) => {
        e.stopPropagation();
        if (bag.dataset.loading === "true") return;
        closeBag();
      });
    }

    document.addEventListener("click", (e) => {
      if (!card.contains(e.target)) closeBag();
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    const cards = document.querySelectorAll(".cp-card");
    if (!("IntersectionObserver" in window)) {
      cards.forEach(init);
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            init(entry.target);
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "120px" }
    );

    cards.forEach((c) => io.observe(c));
  });

  window.cpInitCards = function (root) {
    const cards = (root || document).querySelectorAll(".cp-card");
    if (!("IntersectionObserver" in window)) {
      cards.forEach(init);
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            init(entry.target);
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "120px" }
    );

    cards.forEach((c) => io.observe(c));
  };
})();
